import type { ButtonContainerElementProps } from './types';

const usePresenter = (props: ButtonContainerElementProps): ButtonContainerElementProps => {
  return props;
};
export default usePresenter;
